import { Model } from "pinia-orm";
import { formatTaskResult } from "@/utils/taskResult.js";

export default class TaskResult extends Model {
  static name = "TaskResult";
  static entity = "taskResults";
  static primaryKey = "taskId";

  static fields() {
    return {
      taskId: this.uid(""),
      status: this.string(""),
      taskName: this.string(""),
      dateCreated: this.string(""),
      dateDone: this.string(""),
      taskKwargs: this.attr({}),
      taskArgs: this.attr([]),
      auditUuid: this.string(""),
      formattedKwargs: this.attr({}),
      taskType: this.string(""),
      result: this.attr(null),
      isDisplayed: this.boolean(true),
    };
  }
  static creating(model, record) {
    const formattedRecord = formatTaskResult(record);
    Object.assign(model, formattedRecord);
  }
  static updating(model, record) {
    const formattedRecord = formatTaskResult(record);
    Object.assign(model, formattedRecord);
  }
}
